import { validateStringField } from 'utils/validations/validateStringField';

export const handleValidation = (organization) => {
    const {title} = organization;

    validateStringField(title, 'the organization title');
};